import { useCallback } from 'react';
import { useColor } from './useColor';
export function useSaturationAndLight() {
  var manager = useColor();
  var hsl = manager.getColor().getHSL();
  var onChange = useCallback(function (sl) {
    manager.emitColorChange(manager.getColor().setSL(sl));
  }, []);
  return [hsl, onChange];
}